import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { Card, CardBody, Col, FormGroup, Row } from 'reactstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast from 'react-hot-toast';
import beautify, { JSBeautifyOptions } from 'js-beautify';

const ArmyBookPrintComponent: React.FC<Props> = ({ book }) => {
  const options = {
    indent_size: 2,
    max_preserve_newlines: 2,
    preserve_newlines: true,
    keep_array_indentation: true,
    break_chained_methods: false,
    indent_scripts: 'separate',
    brace_style: 'expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: false,
    end_with_newline: true,
    wrap_line_length: 0,
    indent_inner_html: false,
    comma_first: false,
    e4x: false,
    indent_empty_lines: false,
  } as JSBeautifyOptions;
  const data = book;
  let json = beautify.js(JSON.stringify(data).replace(/\}\]/g, "}\n]"), options);

  const copied = () => toast.success('Copied!');

  return (
    <section>
      <Row className="content justify-content-center">
        <Col xs={12} sm={6}>
          <div className="text-center">
            <h2>Army Book Print</h2>
            <p>You can download it as json file.</p>

            <Card className="card-border">
              <CardBody>
                <FormGroup row={true}>
                  <Col xs="12">
                    <textarea className="form-control" rows={10}>
                      {json}
                    </textarea>
                  </Col>
                </FormGroup>
              </CardBody>
              <div className="mb-2 text-center">
                <CopyToClipboard text={json} onCopy={() => copied()}>
                  <button className="btn btn-age">
                    <i className="fa actions fa-copy" /> Copy to clipboard
                  </button>
                </CopyToClipboard>
              </div>
            </Card>
          </div>
        </Col>
      </Row>
    </section>
  );
};

const mapStateToProps = (state: AppState) => ({
  book: state.armyBook.entity,
});

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArmyBookPrintComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
